import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import { ImageFormRowProps } from 'types';

const NameFormRow = ({ useFormReturn, nodeDataSave }: ImageFormRowProps) => {
  const {
    formState: { errors },
    register,
  } = useFormReturn;

  return (
    <FormRow label="이름" direction="row" labelWidth={100} pos="left">
      <Input
        style={{ maxWidth: '292px' }}
        {...register('name', { required: '이름을 입력해주세요', onBlur: nodeDataSave })}
        error={errors?.name?.message}
      />
    </FormRow>
  );
};

export default NameFormRow;
